import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { store, link } from './_helpers';
import { App } from './App';


import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import axios from 'axios';


axios.defaults.baseURL = `${link}/api/v1`;


axios.interceptors.response.use(response => {
    return response
}, error => {
    if (error.response.status === 401 || error.response.status === 403) {
        localStorage.clear();
        window.location.reload();
    }
    else {
        return Promise.reject(error)
    }
})




if (window.navigator && navigator.serviceWorker) {
    navigator.serviceWorker.getRegistrations()
        .then(function (registrations) {
            for (let registration of registrations) {
                registration.unregister();
            }
        });
}

render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('app')
);


// WEBPACK FOOTER //
// ./src/index.js